export const PATHS = {
  HOME: '/',
  CART: '/',
  CHECKOUT: '/checkout',
  BILLING: '/checkout#billing',
  REVIEW: '/checkout#review',
}
